import { User } from '../user/user';

export class Attachment {
    id: number;
    url: string;
    data: string;
    user: User;
    mime: string;
    name: string
    size: string;
    refId: number;
}
